import type { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'

export const isB2B = (context: SiteContextModeEnum) => context.includes('b2b')
